import { service } from "@ember/service";
import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class ProjectsCreateController extends Controller {
  @service router;
  @service current;
  @service store;

  get organization() {
    return this.model;
  }

  name = "";
  color;

  onChange = ({ name }) => (this.name = name);

  createProjectTask = task(async () => {
    let { name, organization, color } = this;
    let project = this.store.createRecord("project", {
      name,
      organization,
      color,
    });
    await this.store.request(saveRecord(project)).catch((error) => {
      project.unloadRecord();
      throw error;
    });

    this.router.transitionTo("organization.overview", { queryParams: { project: project.id } });
  });
}
